<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap></v-layout>
  </v-container>
</template>

<script>
import Services from "@/services/Services";
export default {
  data() {
    return {
      company_id: null,
      sub_company_id: null,
      items: [],
      progBar: false,
      queryParams: {
        search: null,
        limit: 10,
        offset: 0
      },
      openPanel: [true],
      headers: [
        {
          text: "TERMINAL",
          align: "left",
          value: "terminal"
        },
        {
          text: "ASSIGNED",
          align: "center",
          value: "assigned"
        },
        {
          text: "DISPATCHED",
          align: "center",
          value: "dispatched"
        },
        {
          text: "TICKET",
          align: "center",
          value: "ticket"
        }
      ],
      itemsTerminal: [],
      value: 0
    };
  },

  computed: {},
  created: async function() {
    // await this.getData();
  },
  methods: {
    search(data) {
      this.queryParams.search = data;
      this.queryParams.offset = 0;
      this.getData();
    },
    async getData() {
      // Start Loading
      this.queryParams.company_id = this.$store.state.company.id;
      this.queryParams.sub_company_id = this.$store.state.subcompany.id;

      this.$store.dispatch("startLoading");
      try {
        // Query Data
        let response = (await Services.getDashboard(this.queryParams)).data;

        // Assign the reponse data to items to be display on table
        this.items = response.data;
        this.itemsTerminal = this.items.terminal_statistics;
        console.log(this.items.running_bus);
      } catch (error) {
        if (!error.response) {
          if (!this.$isEmpty(this.$store.state.employee)) {
            this.$infoBar({
              type: "error",
              text: "No network or server connection"
            });
          } else {
            this.$store.dispatch("dispatchUnauthorized", true);
          }
        } else {
          console.log(error.response.status);
          if (error.response.status === 403) {
            this.$store.dispatch("dispatchUnauthorized", true);
          }
        }
      }
      this.$store.dispatch("endLoading");
      this.progBar = false;
    },
    refreshData() {
      this.progBar = true;
      this.getData();
    }
  }
};
</script>

<style>
.scroll {
  overflow-y: auto;
}
</style>